export default "__VITE_ASSET__BTEjyB57__"